import {LitElement, html, css, customElement, property, query} from "lit-element"
import { GlobalCSS } from "../css"

//import assetHeaderImg from '../../assets/images/lucia.jpg'

const goCode = `                      

package main

import ( "fmt" "math" ) 

func main() {
    for { 
        fmt.Print("Geben Sie die Zahl an:")
        var a float64 fmt.Scanf("%f", &a)

        if a < 0 {
            panic("Es ist leider negativ.")
        }

        var a2 float64 = math.Sqrt(a)
        fmt.Printf("\nDie Wurzel ist: %f", a2) fmt.Print("\nWollen Sie denn noch eine Wurzel ziehen?")
        var z string
        fmt.Scanf("%s", &z)

        if z != "ya" {
            break
        } 
    }

    fmt.Println("\nTschüss...")
}
`

export class GBPage extends LitElement {
    @query("#navigation-marker")
    navMarker;
    inHeaderArea = true;  

    constructor() {
        super()
        // this.myProperty = '' // Default value
    }

    scrollToElement(id: string) {
        this.shadowRoot.getElementById(id).scrollIntoView();
    }

    handleGlobalScroll() {
        const offset = this.navMarker.getBoundingClientRect().top;

        if ( offset < 0 && this.inHeaderArea) {
            this.inHeaderArea = false;
            const cEv = new CustomEvent("headerarea", {
                detail: {
                    inHeaderArea: this.inHeaderArea
                }
            });

            this.dispatchEvent(cEv);
        } else if (offset > 0 && !this.inHeaderArea) {
            this.inHeaderArea = true;
            const cEv = new CustomEvent("headerarea", {
                detail: {
                    inHeaderArea: this.inHeaderArea
                }
            });

            this.dispatchEvent(cEv);
        }

    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('scroll', this.handleGlobalScroll.bind(this));
        
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleGlobalScroll.bind(this));
        super.disconnectedCallback();
    }

    async sendContactForm() {
        const form = this.shadowRoot.getElementById("contact-form") as HTMLFormElement
        const formData = new FormData(form)

        const api = {
            name: "mail",
            version: "v1",
            function: `send/external/78f5bde1-69b1-4927-9d06-03999f699287`,
        }

        try {
            await fetch(`https://${api.name}-${api.version}.apis.cedgetec.com/${api.function}`, {
                method: "POST",
                headers: new Headers(),
                body: formData,
            })
            form.reset()
            alert("E-Mail was sent out!")
        } catch (err) {
            form.reset()
            alert("Oooops! The E-Mail could not be sent out! Please contact the global support.")
        }
    }


    render() {
        return html``
    }

    static styles = [GlobalCSS, css`
    `]
}